import api from '.'

export const dataTypeTags = {
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/data-type-tags`, data, success, fail)
  },
  listForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/data-type-tags`, null, success, fail)
  },
  update (tagId, data, success, fail) {
    api.authenticatedRequest('PUT', `/data-type-tags/${tagId}`, data, success, fail)
  },
  delete (tagId, success, fail) {
    api.authenticatedRequest('DELETE', `/data-type-tags/${tagId}`, null, success, fail)
  }
}
